export default {
    campingLaPinede: {
        nl: {
            intro: {
                title: 'Boek een camperplaats',
                par1: 'Welkom op camping La Pinéde',
                par2: 'Momenteel zijn we in de wintermodus. Dat betekent dat alleen campers zijn toegelaten. De receptie is geopend van ma - vr van 08.00 tot 16.30. Een verwamd sanitairgebouw is geopend. Onze shop is gesloten en er is helaas geen broodjesservice.',
                par3: 'Je kunt hier een camperplaats boeken en direct inchecken. Betalen doet u via de pinterminal. Een plattegrond vindt u naast deze zuil waarop ook de inloggegevens staan voor de WiFI en onze App.',
            },
            book: {
                start: {
                    nl: 'Boek een camperplaats',
                    en: 'Book a motorhome pitch',
                    de: 'Wohnmobilplatz buchen',
                    fr: 'Réserver un emplacement pour camping-car',
                    it: 'Prenota un posto per camper',
                    es: 'Reservar una parcela para autocaravana',
                    pt: 'Reserve um lugar para autocaravana',
                },
            },
            navigation: {
                guide: 'Loop je tegen een probleem aan, of in geval van nood, bel {phone_number}',
            },
            stayDuration: {
                available: 'Voldoende plaatsen beschikbaar.',
            },
            pin: {
                description: {
                    par2: 'U heeft ongeveer 30 seconden om de betaling te voldoen.',
                    par3: null,
                },
            },
        },
        en: {
            intro: {
                title: 'Book a motorhome pitch',
                par1: 'Welcome to Camping La Pinéde',
                par2: 'We are currently in winter mode. This means only motorhomes are allowed. Reception is open Mon - Fri from 08:00 to 16:30. A heated sanitary building is open. Our shop is closed and unfortunately there is no bread service.',
                par3: 'You can book a motorhome pitch here and check in immediately. You pay via the payment terminal. A map can be found next to this kiosk, which also shows the login details for the WiFi and our app.',
            },
            book: {
                start: {
                    nl: 'Boek een camperplaats',
                    en: 'Book a motorhome pitch',
                    de: 'Wohnmobilplatz buchen',
                    fr: 'Réserver un emplacement pour camping-car',
                    it: 'Prenota un posto per camper',
                    es: 'Reservar una parcela para autocaravana',
                    pt: 'Reserve um lugar para autocaravana',
                },
            },
            navigation: {
                guide: 'In case of booking problems, or emergency, please call {phone_number}',
            },
            stayDuration: {
                available: 'Plenty of spots available.',
            },
            pin: {
                description: {
                    par2: 'You have about 30 seconds to complete the payment.',
                    par3: null,
                },
            },
        },
        de: {
            intro: {
                title: 'Buchen Sie einen Wohnmobilplatz',
                par1: 'Willkommen auf dem Campingplatz La Pinède.',
                par2: 'Wir befinden uns derzeit im Wintermodus. Das bedeutet, dass nur Wohnmobile zugelassen sind. Die Rezeption ist von Mo - Fr von 08:00 bis 16:30 Uhr geöffnet. Ein beheiztes Sanitärgebäude ist geöffnet. Unser Shop ist geschlossen und es gibt leider keinen Brötchenservice.',
                par3: 'Hier können Sie einen Wohnmobilplatz buchen und direkt einchecken. Bezahlen können Sie über das Zahlungsterminal. Einen Lageplan finden Sie neben dieser Säule; dort stehen auch die Anmeldedaten für das WLAN und unsere App.',
            },
            book: {
                start: {
                    nl: 'Boek een camperplaats',
                    en: 'Book a motorhome pitch',
                    de: 'Wohnmobilplatz buchen',
                    fr: 'Réserver un emplacement pour camping-car',
                    it: 'Prenota un posto per camper',
                    es: 'Reservar una parcela para autocaravana',
                    pt: 'Reserve um lugar para autocaravana',
                },
            },
            navigation: {
                guide: 'Wenn es Buchungsprobleme gibt, oder im Notfall, rufen Sie bitte die {phone_number} an',
            },
            stayDuration: {
                available: 'Genügend Plätze verfügbar.',
            },
            pin: {
                description: {
                    par2: 'Sie haben etwa 30 Sekunden Zeit, um die Zahlung abzuschließen.',
                    par3: null,
                },
            },
        },
        fr: {
            intro: {
                title: 'Réservez un emplacement pour camping-car',
                par1: 'Bienvenue au camping La Pinéde',
                par2: 'Nous sommes actuellement en mode hiver. Cela signifie que seuls les camping-cars sont autorisés. La réception est ouverte du lun au ven de 08h00 à 16h30. Un bâtiment sanitaire chauffé est ouvert. Notre boutique est fermée et il n’y a malheureusement pas de service de pain.',
                par3: 'Vous pouvez réserver ici un emplacement pour camping-car et vous enregistrer directement. Vous payez via le terminal de paiement. Un plan est disponible à côté de cette borne, où figurent également les identifiants pour le Wi-Fi et notre application.',
            },
            book: {
                start: {
                    nl: 'Boek een camperplaats',
                    en: 'Book a motorhome pitch',
                    de: 'Wohnmobilplatz buchen',
                    fr: 'Réserver un emplacement pour camping-car',
                    it: 'Prenota un posto per camper',
                    es: 'Reservar una parcela para autocaravana',
                    pt: 'Reserve um lugar para autocaravana',
                },
            },
            navigation: {
                guide: 'En cas de problème de réservation, ou d’urgence, appeler le {phone_number}',
            },
            stayDuration: {
                available: 'Suffisamment d’emplacements disponibles.',
            },
            pin: {
                description: {
                    par2: 'Vous disposez d’environ 30 secondes pour effectuer le paiement.',
                    par3: null,
                },
            },
        },
        it: {
            intro: {
                title: 'Prenota un posto per camper',
                par1: 'Benvenuto al campeggio La Pinéde',
                par2: 'Siamo attualmente in modalità invernale. Ciò significa che sono ammessi solo i camper. La reception è aperta dal lun al ven dalle 08:00 alle 16:30. È aperto un edificio sanitario riscaldato. Il nostro negozio è chiuso e purtroppo non c’è servizio pane.',
                par3: 'Qui puoi prenotare un posto per camper e fare subito il check-in. Il pagamento avviene tramite il terminale di pagamento. Una mappa si trova accanto a questa colonnina, dove trovi anche i dati di accesso al WiFi e alla nostra app.',
            },
            book: {
                start: {
                    nl: 'Boek een camperplaats',
                    en: 'Book a motorhome pitch',
                    de: 'Wohnmobilplatz buchen',
                    fr: 'Réserver un emplacement pour camping-car',
                    it: 'Prenota un posto per camper',
                    es: 'Reservar una parcela para autocaravana',
                    pt: 'Reserve um lugar para autocaravana',
                },
            },
            navigation: {
                guide: 'Se riscontri problemi o in caso di emergenza, chiama {phone_number}',
            },
            stayDuration: {
                available: 'Sono disponibili posti a sufficienza.',
            },
            pin: {
                description: {
                    par2: 'Hai circa 30 secondi per completare il pagamento.',
                    par3: null,
                },
            },
        },
        es: {
            intro: {
                title: 'Reserva una parcela para autocaravana',
                par1: 'Bienvenido al camping La Pinéde',
                par2: 'Actualmente estamos en modo invierno. Esto significa que solo se permiten autocaravanas. La recepción está abierta de lun a vie de 08:00 a 16:30. Hay un edificio sanitario climatizado abierto. Nuestra tienda está cerrada y lamentablemente no hay servicio de pan.',
                par3: 'Aquí puedes reservar una parcela para autocaravana y hacer el check-in de inmediato. Pagas a través del terminal de pago. Encontrarás un plano junto a este tótem, donde también están los datos de acceso para el WiFi y nuestra app.',
            },
            book: {
                start: {
                    nl: 'Boek een camperplaats',
                    en: 'Book a motorhome pitch',
                    de: 'Wohnmobilplatz buchen',
                    fr: 'Réserver un emplacement pour camping-car',
                    it: 'Prenota un posto per camper',
                    es: 'Reservar una parcela para autocaravana',
                    pt: 'Reserve um lugar para autocaravana',
                },
            },
            navigation: {
                guide: 'Si encuentras problemas, o en caso de emergencia, llama al {phone_number}',
            },
            stayDuration: {
                available: 'Hay suficientes plazas disponibles.',
            },
            pin: {
                description: {
                    par2: 'Tienes unos 30 segundos para completar el pago.',
                    par3: null,
                },
            },
        },
        pt: {
            intro: {
                title: 'Reserve um lugar para autocaravana',
                par1: 'Bem-vindo ao parque de campismo La Pinéde',
                par2: 'Estamos atualmente em modo de inverno. Isso significa que apenas autocaravanas são permitidas. A receção está aberta de seg a sex das 08h00 às 16h30. Um edifício sanitário aquecido está aberto. A nossa loja está fechada e, infelizmente, não há serviço de pão.',
                par3: 'Aqui pode reservar um lugar para autocaravana e fazer o check-in de imediato. O pagamento é efetuado através do terminal de pagamento. Há um mapa ao lado deste quiosque, onde também encontra os dados de acesso ao Wi-Fi e à nossa app.',
            },
            book: {
                start: {
                    nl: 'Boek een camperplaats',
                    en: 'Book a motorhome pitch',
                    de: 'Wohnmobilplatz buchen',
                    fr: 'Réserver un emplacement pour camping-car',
                    it: 'Prenota un posto per camper',
                    es: 'Reservar una parcela para autocaravana',
                    pt: 'Reserve um lugar para autocaravana',
                },
            },
            navigation: {
                guide: 'Se tiver problemas ou em caso de emergência, ligue para {phone_number}',
            },
            stayDuration: {
                available: 'Há lugares suficientes disponíveis.',
            },
            pin: {
                description: {
                    par2: 'Tem cerca de 30 segundos para concluir o pagamento.',
                    par3: null,
                },
            },
        },
    },
    tacozijl: {
        // Dutch
        nl: {
            intro: {
                // Legacy: 'intro-text-1'
                title: 'Boek een caravan- of camperplaats',
                par1: 'Je kunt hier een caravan- of camperplaats boeken en direct inchecken. Betalen kan direct via de pinterminal.',
                par2: 'Uitgebreide informatie over onze caravanplaats en camperplaatsen vind je op {website_url}',
                // Legacy: 'intro-booking'
                start: 'Start boeking',
                // Legacy: 'intro-text-2'
                subtitle: 'Accommodatie boeken',
                par3: 'Boeken van accommodaties kan uitsluitend bij de receptie tijdens openingstijden of online via {website_url}.',
            },
        },

        // English
        en: {
            intro: {
                title: 'Book a caravan or camper pitch',
                par1: 'You can book a caravan or camper pitch here and check in directly. You can pay directly via the pinterminal.',
                par2: 'More information about our caravan and camper pitches can be found at tacozijl.com',
                start: 'Start booking',
                subtitle: 'Booking accommodation',
                par3: 'Booking accommodation is only possible at the reception during opening hours or online at {website_url}.',
            },
        },

        // German
        de: {
            intro: {
                title: 'Buchen Sie einen Wohnwagen- oder Wohnmobilplatz',
                par1: 'Sie können hier einen Wohnwagen- oder Wohnmobilplatz buchen und direkt einchecken. Bezahlen können Sie direkt über das Pinterminal.',
                par2: 'Umfassende Informationen zu unseren Wohnwagen- und Wohnmobilplätzen finden Sie unter tacozijl.de',
                start: 'Buchung beginnen',
                subtitle: 'Unterkunft buchen',
                par3: 'Die Buchung einer Unterkunft ist nur an der Rezeption während der Öffnungszeiten oder online unter {website_url} möglich.',
            },
        },

        // French
        fr: {
            intro: {
                title: 'Réserver un emplacement pour caravane ou camping-car',
                par1: 'Vous pouvez réserver ici un emplacement pour caravane ou camping-car et vous enregistrer directement. Vous pouvez payer directement via le terminal.',
                par2: "Des informations complètes sur nos emplacements pour caravanes et camping-cars sont disponibles à l'adresse {website_url}",
                start: 'Commencer la réservation',
                subtitle: 'Réserver un logement',
                par3: "La réservation d'un logement est possible uniquement à la réception pendant les heures d'ouverture ou en ligne sur {website_url}.",
            },
        },

        // Italian
        it: {
            intro: {
                title: 'Prenotare una piazzola per roulotte o camper',
                par1: 'Potete prenotare qui una piazzola per roulotte o camper e fare il check-in direttamente. Il pagamento può essere effettuato direttamente tramite il pinterminale.',
                par2: 'Informazioni complete sulle nostre aree per roulotte e camper sono disponibili su {website_url}',
                start: 'Inizia la prenotazione',
                subtitle: 'Prenotare un alloggio',
                par3: "La prenotazione di un alloggio è possibile solo presso la reception durante l'orario di apertura o online su {website_url}.",
            },
        },

        // Spanish
        es: {
            intro: {
                title: 'Reservar una parcela para caravana o autocaravana',
                par1: 'Aquí puede reservar una parcela para caravana o autocaravana y registrarse directamente. Puede pagar directamente a través del pinterminal.',
                par2: 'En {website_url} encontrará información completa sobre nuestros emplazamientos para caravanas y autocaravanas.',
                start: 'Iniciar reserva',
                subtitle: 'Reservar alojamiento',
                par3: 'La reserva de alojamiento solo es posible en recepción durante el horario de apertura o en línea en {website_url}.',
            },
        },

        // Portuguese
        pt: {
            intro: {
                title: 'Reservar um local para caravanas ou autocaravanas',
                par1: 'Pode reservar aqui um terreno para caravanas ou autocaravanas e fazer o check-in diretamente. Pode pagar diretamente através do pinterminal.',
                par2: 'Informações completas sobre os nossos locais para caravanas e autocaravanas podem ser encontradas em {website_url}',
                start: 'Iniciar reserva',
                subtitle: 'Reservar alojamento',
                par3: 'A reserva de alojamento só é possível na receção durante o horário de funcionamento ou online em {website_url}.',
            },
        },
    },
    uiterwaarde: {
        nl: {
            title: 'Parkeerabonnement',
            book: {
                confirm: 'Bevestigen',
            },
            arrangement: {
                unavailable: {
                    title: 'Parkeerabonnement niet beschikbaar',
                    body: 'Het gekozen parkeerabonnement is niet beschikbaar.',
                },
            },
            receipt: {
                validFrom: 'Geldig van {date}',
                validUntil: 'Geldig tot {date}',
            },
            receiptConfirm: {
                paymentLater: 'Na bevestigen kunt u direct de betaling verrichten.',
            },
        },
        en: {
            title: 'Parking subscription',
            book: {
                confirm: 'Confirm',
            },
            arrangement: {
                unavailable: {
                    title: 'Parking subscription unavailable',
                    body: 'The chosen parking subscription is not available.',
                },
            },
            receipt: {
                validFrom: 'Valid from {date}',
                validUntil: 'Valid until {date}',
            },
            receiptConfirm: {
                paymentLater: 'After confirming, you can proceed with payment immediately.',
            },
        },
        de: {
            title: 'Parkabonnement',
            book: {
                confirm: 'Bestätigen',
            },
            arrangement: {
                unavailable: {
                    title: 'Parkabonnement nicht verfügbar',
                    body: 'Das gewählte Parkabonnement ist nicht verfügbar.',
                },
            },
            receipt: {
                validFrom: 'Gültig ab {date}',
                validUntil: 'Gültig bis {date}',
            },
            receiptConfirm: {
                paymentLater: 'Nach der Bestätigung können Sie direkt bezahlen.',
            },
        },
        fr: {
            title: 'Abonnement de parking',
            book: {
                confirm: 'Confirmer',
            },
            arrangement: {
                unavailable: {
                    title: 'Abonnement de parking indisponible',
                    body: 'L\'abonnement de parking choisi n\'est pas disponible.',
                },
            },
            receipt: {
                validFrom: 'Valable à partir du {date}',
                validUntil: 'Valable jusqu\'au {date}',
            },
            receiptConfirm: {
                paymentLater: 'Après confirmation, vous pouvez procéder au paiement immédiatement.',
            },
        },
        it: {
            title: 'Abbonamento parcheggio',
            book: {
                confirm: 'Conferma',
            },
            arrangement: {
                unavailable: {
                    title: 'Abbonamento parcheggio non disponibile',
                    body: 'L\'abbonamento parcheggio selezionato non è disponibile.',
                },
            },
            receipt: {
                validFrom: 'Valido dal {date}',
                validUntil: 'Valido fino al {date}',
            },
            receiptConfirm: {
                paymentLater: 'Dopo la conferma, puoi procedere immediatamente al pagamento.',
            },
        },
        es: {
            title: 'Suscripción de aparcamiento',
            book: {
                confirm: 'Confirmar',
            },
            arrangement: {
                unavailable: {
                    title: 'Suscripción de aparcamiento no disponible',
                    body: 'La suscripción de aparcamiento seleccionada no está disponible.',
                },
            },
            receipt: {
                validFrom: 'Válido desde {date}',
                validUntil: 'Válido hasta {date}',
            },
            receiptConfirm: {
                paymentLater: 'Después de confirmar, puede proceder al pago de inmediato.',
            },
        },
        pt: {
            title: 'Subscrição de estacionamento',
            book: {
                confirm: 'Confirmar',
            },
            arrangement: {
                unavailable: {
                    title: 'Subscrição de estacionamento indisponível',
                    body: 'A subscrição de estacionamento selecionada não está disponível.',
                },
            },
            receipt: {
                validFrom: 'Válido a partir de {date}',
                validUntil: 'Válido até {date}',
            },
            receiptConfirm: {
                paymentLater: 'Após confirmar, pode proceder ao pagamento imediatamente.',
            },
        },
    },
};
